// Lib
import { get } from 'lodash/fp';

export const getUserIdFromAction = (action) => get(['user', '_id'], action) || get('userId', action);
